<template>
    <b-field :label="label"
             :type="error?'is-danger':''"
             :message="error">
        <b-datepicker
                :value="date"
                :placeholder="placeholder"
                :min-date="min"
                :max-date="max"
                @input="setValue"
                :inline="inline"
                icon="calendar">
        </b-datepicker>
    </b-field>
</template>

<script>
    export default {
        name: "FormDate",
        data() {
            return {
                date: new Date()
            }
        },
        props: {
            value: Date|String,
            label: {
                type: String,
                default: 'Selecciona una fecha'
            },
            error: {},
            holder: {
                type: String,
                default: 'Selecciona una fecha'
            },
            inline: {},
            icon: {
                type: String,
                default: 'calendar'
            },
            min: {},
            max: {},
        },
        watch: {
            value(val) {
                if (typeof val === 'string') {
                    this.date = new Date(val);
                }
            }
        },
        mounted() {
            this.date = new Date(this.value || new Date());
        },
        methods: {
            setValue(val) {
                this.$emit('input', moment(val).format());
            }
        }
    }
</script>

<style scoped>

</style>